import {
  ShoppingCart,
  Tags,
  Smile,
  ShoppingBag,
  List,
  Folder,
  BookOpen,
  Bookmark,
  Film,
  Scissors,
  Eye,
  EyeOff,
  Star,
} from "lucide-react";

export const WIDGET_ICON_KEYS = {
  cart: "cart",
  tags: "tags",
  emoji: "emoji",
  basket: "basket",
  list: "list",
  folder: "folder",
  books: "books",
  folderBookmark: "folderBookmark",
  film: "film",
  scissors: "scissors",
  eye: "eye",
  eyeSlash: "eyeSlash",
  star: "star",
};

export const FOLDER_ICON_KEYS = {
  noIcon: "no-icon",
  tags: "tags",
  basket: "basket",
  list: "list",
  folder: "folder",
  emoji: "emoji",
  cart: "cart",
  books: "books",
  folderBookmark: "folderBookmark",
  film: "film",
  scissors: "scissors",
  eye: "eye",
  eyeSlash: "eyeSlash",
  star: "star",
};

export const WIDGET_ICONS_ARRAY = [
  { key: WIDGET_ICON_KEYS.cart, icon: ShoppingCart },
  { key: WIDGET_ICON_KEYS.tags, icon: Tags },
  { key: WIDGET_ICON_KEYS.emoji, icon: Smile },
  { key: WIDGET_ICON_KEYS.basket, icon: ShoppingBag },
  { key: WIDGET_ICON_KEYS.list, icon: List },
  { key: WIDGET_ICON_KEYS.folder, icon: Folder },
  { key: WIDGET_ICON_KEYS.books, icon: BookOpen },
  { key: WIDGET_ICON_KEYS.folderBookmark, icon: Bookmark },
  { key: WIDGET_ICON_KEYS.film, icon: Film },
  { key: WIDGET_ICON_KEYS.scissors, icon: Scissors },
  { key: WIDGET_ICON_KEYS.eye, icon: Eye },
  { key: WIDGET_ICON_KEYS.eyeSlash, icon: EyeOff },
  { key: WIDGET_ICON_KEYS.star, icon: Star },
];

export const FOLDER_ICONS_ARRAY = [
  { key: FOLDER_ICON_KEYS.tags, icon: Tags },
  { key: FOLDER_ICON_KEYS.cart, icon: ShoppingCart },
  { key: FOLDER_ICON_KEYS.basket, icon: ShoppingBag },
  { key: FOLDER_ICON_KEYS.list, icon: List },
  { key: FOLDER_ICON_KEYS.folder, icon: Folder },
  { key: FOLDER_ICON_KEYS.books, icon: BookOpen },
  { key: FOLDER_ICON_KEYS.folderBookmark, icon: Bookmark },
  { key: FOLDER_ICON_KEYS.film, icon: Film },
  { key: FOLDER_ICON_KEYS.scissors, icon: Scissors },
  { key: FOLDER_ICON_KEYS.eye, icon: Eye },
  { key: FOLDER_ICON_KEYS.eyeSlash, icon: EyeOff },
  { key: FOLDER_ICON_KEYS.star, icon: Star },
];

export const getFolderIcon = (iconKey) => {
  if (iconKey == null || iconKey === FOLDER_ICON_KEYS.noIcon) return Folder;
  let folderIcon = FOLDER_ICONS_ARRAY.find((item) => item.key === iconKey)?.icon;
  if (folderIcon) return folderIcon;
  return Folder;
};
